module.exports = {"610523001":"西城街道","610523002":"东城街道","610523101":"许庄镇","610523102":"朝邑镇","610523103":"安仁镇","610523104":"两宜镇","610523105":"羌白镇","610523106":"官池镇","610523107":"冯村镇","610523108":"双泉镇","610523110":"下寨镇","610523111":"韦林镇","610523112":"范家镇","610523113":"苏村镇","610523114":"赵渡镇","610523116":"埝桥镇","610523117":"段家镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610523.json
// module id = 2962
// module chunks = 0